'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.setFiles = setFiles;
exports.setPath = setPath;
exports.setPathCollection = setPathCollection;
exports.setError = setError;
exports.setProcessing = setProcessing;
exports.clearFilesCache = clearFilesCache;
exports.uploadFromCloud = uploadFromCloud;
exports.setCSRFState = setCSRFState;
exports.boxcomGetToken = boxcomGetToken;
exports.boxcomGetFolders = boxcomGetFolders;
exports.boxcomDownloadFile = boxcomDownloadFile;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _update2 = require('react/lib/update');

var _update3 = _interopRequireDefault(_update2);

var _auth = require('./auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_FILES = 'cloud/SET_FILES';
var SET_PATH = 'cloud/SET_PATH';
var SET_PATH_COLLECTION = 'cloud/SET_PATH_COLLECTION';
var SET_ERROR = 'cloud/SET_ERROR';
var SET_PROCESSING = 'cloud/SET_PROCESSING';
var CLEAR_FILES_CACHE = 'cloud/CLEAR_FILES_CACHE';
var SET_CSRF_STATE = 'cloud/SET_CSRF_STATE';

var loadReducer = (0, _loadReducer2.default)('cloud', {
  uploadFromCloud: {},
  boxcomToken: {},
  boxcomGetFolders: {},
  boxcomDownloadFile: {}
});

var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
  dropbox: {
    files: {},
    pathId: '',
    pathCollection: [],
    error: null,
    processing: false,
    csrfState: ''
  },
  boxcom: {
    files: {},
    pathId: '',
    pathCollection: [],
    error: null,
    processing: false,
    csrfState: ''
  },
  service: ''
});

function updateServiceState(service, state, data) {
  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, service, (0, _extends4.default)({}, state[service], data)));
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case SET_FILES:
      return (0, _update3.default)(state, (0, _defineProperty3.default)({}, action.service, {
        files: (0, _defineProperty3.default)({}, action.pathId, { $set: action.files }),
        error: { $set: null }
      }));
    case SET_PATH:
      return updateServiceState(action.service, state, {
        pathId: action.pathId,
        error: null
      });
    case SET_PATH_COLLECTION:
      return updateServiceState(action.service, state, {
        pathCollection: action.pathCollection
      });
    case SET_ERROR:
      return updateServiceState(action.service, state, {
        error: action.error
      });
    case SET_PROCESSING:
      return updateServiceState(action.service, state, {
        processing: action.processing
      });
    case SET_CSRF_STATE:
      return updateServiceState(action.service, state, {
        csrfState: action.csrfState
      });
    case _auth.ACTIONS.SET_BOX_TOKEN_SUCCESS:
    case _auth.ACTIONS.DELETE_BOX_TOKEN_SUCCESS:
    case CLEAR_FILES_CACHE:
      return updateServiceState(action.service, state, {
        files: {},
        error: null
      });
    default:
      return loadReducer.reducer(state, action);
  }
}

function setFiles(_ref) {
  var service = _ref.service,
      pathId = _ref.pathId,
      files = _ref.files;

  return {
    type: SET_FILES,
    service: service,
    pathId: pathId,
    files: files
  };
}

function setPath(service, pathId) {
  return {
    type: SET_PATH,
    service: service,
    pathId: pathId
  };
}

function setPathCollection(service, pathCollection) {
  return {
    type: SET_PATH_COLLECTION,
    service: service,
    pathCollection: pathCollection
  };
}

function setError(service, error) {
  return {
    type: SET_ERROR,
    service: service,
    error: error
  };
}

function setProcessing(service, processing) {
  return {
    type: SET_PROCESSING,
    service: service,
    processing: processing
  };
}

function clearFilesCache(service) {
  return {
    type: CLEAR_FILES_CACHE,
    service: service
  };
}

function uploadFromCloud(_ref2) {
  var projectId = _ref2.projectId,
      name = _ref2.name,
      url = _ref2.url,
      _ref2$part = _ref2.part,
      part = _ref2$part === undefined ? 1 : _ref2$part,
      _ref2$replacedId = _ref2.replacedId,
      replacedId = _ref2$replacedId === undefined ? 0 : _ref2$replacedId;

  return {
    types: loadReducer.constantsByKey.uploadFromCloud,
    promise: function promise(client) {
      return client.post('FileUpload_wa/uploadAudioVideoFromURL', { data: { projectId: projectId, url: url, part: part, replacedId: replacedId, qqfilename: name } });
    },
    projectId: projectId,
    url: url,
    name: name
  };
}

function setCSRFState(service, csrfState) {
  return {
    type: SET_CSRF_STATE,
    service: service,
    csrfState: csrfState
  };
}

function boxcomGetToken(authCode) {
  return {
    types: loadReducer.constantsByKey.boxcomToken,
    promise: function promise(client) {
      return client.post('boxcom/token', { json: true, data: { authCode: authCode } });
    },
    authCode: authCode
  };
}

function boxcomGetFolders(path) {
  return {
    types: loadReducer.constantsByKey.boxcomGetFolders,
    promise: function promise(client) {
      return client.get('boxcom/folders', { json: true, params: { path: path } });
    },
    pathId: path
  };
}

function boxcomDownloadFile(_ref3) {
  var fileId = _ref3.fileId,
      fileName = _ref3.fileName,
      projectId = _ref3.projectId;

  return {
    types: loadReducer.constantsByKey.boxcomDownloadFile,
    promise: function promise(client) {
      return client.post('boxcom/download-file', { json: true, data: { fileId: fileId, fileName: fileName, projectId: projectId } });
    },
    fileId: fileId,
    fileName: fileName,
    projectId: projectId
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/cloud.js
// module id = 216
// module chunks = 1